module.exports = __webpack_public_path__ + "static/media/braille.c055c287.svg";